// FIXME: Duplication code with offer
// Section specific scripts come here
import Swiper from '@src/components/swiper';
import { ScreensInt } from '@tailwindConfig/screens.config';
import { screenResizerChecker } from '../../javascript/src/utils/screen-resizer-checker';

function nextOrPrevSlider($slider) {
  const selector = '.slider-sticky-navigation-item';
  return $slider.next(selector).data('price-name') || $slider.prev(selector).data('price-name');
}

// This function will manipulate the following pairs:
// * priceNameNewValue with $changingSelect
// * priceNameCompareTo with $compareSelect
// The first pair is the select that the user just changed
// The second will be change to the closest value
function swapSelectOnSlideChange(activeIndex, $slider) {
  if ($slider.parents('.alt-page').hasClass('hidden')) { return false; };
  const priceNameNewValue = $slider.data('price-name');
  const priceNameCompareTo = nextOrPrevSlider($slider);
  let $changingSelect = $('.select-table:visible:last');
  let $compareSelect = $('.select-table:visible:first');
  if (activeIndex == 0) {
    $changingSelect = $('.select-table:visible:first');
    $compareSelect = $('.select-table:visible:last');
  }
  const selectValue = $changingSelect.val();
  const option_values = $.map($changingSelect.find('option'), e => $(e).val());
  if (option_values.length == 2 &&
    selectValue != priceNameNewValue &&
    option_values.includes(priceNameNewValue)) {
    $changingSelect.val(priceNameNewValue).change();
    $compareSelect.val(priceNameCompareTo).change();
  }
};

function changeNavigationActiveIndex(activeIndex) {
  $('.slider-sticky-navigation-item b').removeClass('border-b-1');
  $('.slider-sticky-navigation-item').each(function () {
    if ($(this).data('slide-index') == activeIndex) {
      $(this).find('b').addClass('border-b-1');
      swapSelectOnSlideChange(activeIndex, $(this));
    }
  });
}

function swiperOverviewCards() {
  if ($('.swiper-container-overview-cards').length) {
    // breakpoint where swiper will be destroyed
    // FIXME THIS SHOULD BE MOVE ON A TOP LEVEL ?
    const urlParams = new URLSearchParams(window.location.search);
    // - 1 to give Content Loaders a more human readable index (not starting from 0)

    let target_index;
    if (urlParams.get('sm-overview')) {
      target_index = parseInt(urlParams.get('sm-overview')) - 1;
    }
    if (target_index == NaN || target_index == null) {
      target_index = undefined;
    }

    let currentOverviewSwipers;
    const breakpoint = window.matchMedia(`(min-width:${ScreensInt.md}px)`);

    const destroySwiper = function () {
      const overviewSwipers = document.querySelectorAll('.alt-page.hidden .swiper-container-overview-cards');

      overviewSwipers.forEach((element) => {
        if (element.swiper) {
          element.swiper.destroy(true, true);
        }
      });
    };

    const enableSwiper = function () {
      const overviewSwipers = document.querySelectorAll('.swiper-container-overview-cards');

      overviewSwipers.forEach((element) => {
        new Swiper(element, {
          centeredSlides: true,
          a11y: true,
          keyboardControl: true,
          grabCursor: true,
          spaceBetween: 24,
          slidesPerView: 1.2,
          on: {
            activeIndexChange: function () {
              changeNavigationActiveIndex(this.activeIndex);
            }
          }
        });
      });

      changeNavigationActiveIndex(0);

      // Preselect via sm-overview parameter
      if (target_index != undefined) selectSwiperOverview(target_index);
    };

    const selectSwiperOverview = function (index, pageId) {
      if (!currentOverviewSwipers) { return; }
      // only one swiper
      if (currentOverviewSwipers.length == undefined) {
        currentOverviewSwipers.slideTo(index);
        return;
      }

      // multiple
      for (let i = 0; i < currentOverviewSwipers.length; i += 1) {
        const swiper = currentOverviewSwipers[i];
        if ($(swiper.el).parents(pageId).length) {
          swiper.slideTo(index);
        }
      }
    };

    const destroySwiperOnDesktop = () => {
      const overviewSwipers = document.querySelectorAll('.swiper-container-overview-cards');
      overviewSwipers.forEach((element) => {
        if (element.swiper) {
          element.swiper.destroy(true, true);
        }
      });
    };

    // keep an eye on viewport size changes
    screenResizerChecker(enableSwiper, destroySwiperOnDesktop, ScreensInt.md);

    // Remove control of the swiper (see click bidding below)
    $('.slider-sticky-navigation-item').on('slideTo', function () {
      target_index = $(this).data('slide-index');
      $('.swiper-container-overview-cards').each(function (_index) {
        const swiper = this.swiper;
        if (swiper) swiper.slideTo(target_index);
      });
    });

    // Click biding for sticky navigation items
    $('.slider-sticky-navigation-item').click(function () {
      target_index = $(this).data('slide-index');
      changeNavigationActiveIndex(target_index);
      $(this).trigger('slideTo');
    });

    // Return true is element is in view port
    // FIXME: should be made a global function
    const isInViewport = function ($el) {
      if (!$el.offset()) return false;
      const top_of_element = $el.offset().top;
      const bottom_of_element = $el.offset().top + $el.outerHeight();
      const bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
      const top_of_screen = $(window).scrollTop() + ($el.outerHeight() / 2);

      return (bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element);
    };

    // FIXME THIS CAN BE MADE A TOOL AS WELL
    document.addEventListener('scroll', function () {
      const planSection = $('.price-plan-overview-cards-section:visible').first();
      if (isInViewport(planSection)) {
        $('.slider-sticky-navigation-overview').removeClass('hidden');
        if (target_index) {
          changeNavigationActiveIndex(target_index);
        }
      } else {
        $('.slider-sticky-navigation-overview').addClass('hidden');
      }
      if ($('.slider-sticky-navigation:visible').length) {
        $('.drift-frame-controller').css('margin-top', '-60px');
      } else {
        $('.drift-frame-controller').css('margin-top', '0');
      }
    });

    $('.alt-page-tab').on('classChange', function () {
      destroySwiper();
    });

    // ----- Handle business needs for mobile scroll
    $(
      'section.price-plan-overview-cards-section'
    ).on('init-section', function (event, params) {
      const pageId = '#' + params.page[0].id;
      event.stopPropagation();

      const bp = (breakpoint.matches === true);
      if (bp || (!target_index) || (!currentOverviewSwipers)) { return; }

      selectSwiperOverview(target_index, pageId);
    });
  }
}

swiperOverviewCards();

export {
  changeNavigationActiveIndex,
  swiperOverviewCards,
  swapSelectOnSlideChange
};
